















































import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {FormValidate} from '@/services/form-validate';
import {Action} from 'vuex-class';
import {Toast} from '@/store/toast/toast.types';
import {ChangePassword} from '@/store/member/member.types';
import {AuthEnum} from '@/store/auth/auth.enum';
import {LoginForm, LoginInfo} from '@/store/auth/auth.types';
import {ResponseCode} from '@/class/http';

@Component({
  components: {}
})
export default class ChangePasswordComponent extends Vue {

  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_updatePasswordMember', {namespace: 'member'}) updatePasswordMember!: (payload: ChangePassword) => Promise<void>;
  @Action('_weakPassword', {namespace: 'auth'}) weakPassword!: () => Promise<void>;

  public showPassword = true;
  public showPasswordConfirm = true;
  public Password = {
    password: '',
    confirmPassword: ''
  };
  public loginInfo: LoginInfo = JSON.parse(localStorage.getItem(AuthEnum.Auth) as string) as LoginInfo;


  async ChangePassword() {
    if (this.Password.password === '' || this.Password.confirmPassword === '') {
      this.Toast({
        heading: '!',
        message: 'กรุณากรอกข้อมูลให้ครบ',
        type: 'danger'
      }).then();
      return;
    }
    if (this.Password.password !== this.Password.confirmPassword) {
      this.Toast({
        heading: 'รหัสผ่านไม่ตรงกัน',
        message: 'กรุณาลองกรอกข้อมูลใหม่อีกครั้ง',
        type: 'danger'
      }).then();
      return;
    }

    let resMember = await this.updatePasswordMember({
      id: this.loginInfo.id,
      password: this.Password.password,
      weakPassword: false
    });

    let stats = JSON.parse(JSON.stringify(resMember)).data as ResponseCode;
    if (stats.appCode === 20002) {
      this.Toast({
        message: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้ว',
        heading: 'บันทึกข้อมูลสำเร็จ',
        type: 'success',
      });
      await this.weakPassword();
      await this.$router.push('/main');
    } else {
      this.Toast({
        message: 'กรุณาลองใหม่อีกครั้ง',
        heading: 'เปลี่ยนรหัสผ่านไม่สำเร็จ',
        type: 'warning',
      });
    }

  }

}
